import { Event, DestinationPlugin } from '@amplitude/analytics-types';

export class AmplitudeGTMPlugin implements DestinationPlugin {
  name = 'AmplitudeGTMPlugin';
  type = 'destination' as const;

  // eslint-disable-next-line require-await
  async setup() {
    window.dataLayer = window.dataLayer || [];
  }

  // eslint-disable-next-line require-await
  async execute(event: Event) {
    if (event.event_type === '$identify') {
      window.dataLayer!.push({
        event: 'addedStateKeyToUser',
        state_key: event.user_id!,
      });
    } else {
      window.dataLayer!.push({
        event: 'amplitude_event',
        event_type: event.event_type,
        event_properties: event.event_properties,
      });
    }

    return {
      code: 200,
      event: event,
      message: 'Event pushed onto GTM Data Layer',
    };
  }
}
